import { render, staticRenderFns } from "./MessagePhoneNumberEntityRegexpTypeSetupView.vue?vue&type=template&id=2c0a8878&scoped=true&"
import script from "./MessagePhoneNumberEntityRegexpTypeSetupView.vue?vue&type=script&lang=ts&"
export * from "./MessagePhoneNumberEntityRegexpTypeSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a8878",
  null
  
)

export default component.exports